import React, { FC } from "react";
import { Card } from "../../../Card/Card";
import {Divider} from "../../../Divider/Divider";
import {Icons} from "../../../../SvgIcon/types";

export interface QuickBookingSectionType {
    onSelect: () => void;
    heading: string;
    bookingName: string;
    description?: string;
    icon?: string;
}

export const QuickBookingSection: FC<QuickBookingSectionType> = ({
    onSelect,
    heading,
    bookingName,
    description,
    icon,
}) => (
    <div className="QuickBookingSection">
        <h2 className="QuickBookingSection__heading" >{heading}</h2>
        
        <button type="button" className="QuickBookingSection__cardBtn" onClick={onSelect}>
            <Card
                heading={bookingName}
                className="QuickBookingSection__card"
                iconName={icon as Icons}
                description={description}
            />
        </button>
        
        <Divider className="QuickBookingSection__divider"/>
    </div>
);
